import React from "react";
import { useFormContext } from "react-hook-form";
import { RHFTextField } from "../../hook-form/RHFTextField";
import { RHFDatePicker } from "../../hook-form/RHFDateSelect";
import { Box, Button } from "@mui/material";
import { PostSiliconPayload } from "../../../types/Silicon";

export interface SiliconFormProps {
  operatorId: number;
}

export function SiliconForm({ operatorId }: SiliconFormProps) {
  const {
    control,
    formState: { errors },
  } = useFormContext<PostSiliconPayload>();

  return (
    <Box display="flex" flexDirection="column" gap={3}>
      <RHFTextField
        name="batchNumber"
        label="Chargen Nr."
        control={control}
        required
        error={!!errors.batchNumber}
        helperText={errors.batchNumber?.message}
      />

      <RHFDatePicker
        name="expirationDate"
        label="Ablaufdatum"
        control={control}
        textFieldProps={{
          error: !!errors.expirationDate,
          helperText: errors.expirationDate?.message,
        }}
      />

      <Button type="submit" variant="contained">
        Speichern
      </Button>
    </Box>
  );
}
